import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReportComponent } from "./index";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";
import { CalendarModule } from "primeng/calendar";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { FileUploadModule } from "primeng/fileupload";
import { HttpClientModule } from "@angular/common/http";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { AccordionModule } from "primeng/accordion";
import { CheckboxModule } from "primeng/checkbox";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import {
	AdvisoryHRAttendanceComponent,
	AttendanceByTypeComponent,
	AttendanceWithGroupingComponent,
	EntryAlertComponent,
	ClassRosterComponent,
	DailyMealCodesComponent,
	EntryStatusByTimeComponent,
	MealsChargedBySubsidyComponent,
	EntryTypeComponent,
	StudentWithoutPhotosComponent,
	StudentTardiesWithTimesComponent,
	TimeStampScanningComponent,
	StudentStatusForTheDayComponent,
	StudentAbsentTardyExcuseComponent,
	PerfectAttendanceComponent,
	ClassAttendanceTrackingComponent,
	IDCardsPrintedComponent,
	//ScanStationAttendanceComponent
	StudentAttendanceHistoryComponent,
	StudentAttendanceStatusComponent,
	StudentClassAttendanceComponent,
	InstructorMissingSectionComponent,
	StudentClassAttendanceReconciliationComponent,
	PhotoBookComponent,
	ScanStationAttendancesComponent,
	StudentWithAlertComponent,
	VisitorlogsbydateComponent,
	ConvertedIncidentsComponent,
	//DetentionBalanceComponent,
	//DetentionOwedComponent,
	InOutOfSchoolSuspensionsComponent,
	StudentsByInfractionComponent,
	StudentsWithMissingAlertsComponent,
	SuspensionWorkflowDetailComponent,
	//SuspensionsNotAssignedMaximumComponent

	//Generated
	AlphaStudentDetailsComponent,
	AttendancebyDayComponent,
	AttendanceSummaryComponent,
	CutsAbsenceTardyComponent,
	EarlyReleaseComponent,
	//EntryTypeComponent,
	ExceptionStationComponent,
	ScanStationsSummaryComponent,
	WeeklyHomeroomSheetComponent,
	// StudentStatusForTheDayComponent,
	StudentCutsMTDYTDComponent,
	StudentCutsMTDYTDDetailComponent,
	StudentsonSuspensionComponent,
	// StudentsWithoutPhotosComponent,
	LockersComponent,
	//PerfectAttendanceComponent,
	StudentCutsbyNumberComponent,
	StudentMealSubsidyTypesComponent,
	//EntryAlertComponent,
	AlphaStaffComponent,
	StudentIDCardHistoryComponent,
	AlphaStudentListComponent,
	EntryTypeCountsComponent,
	HomeroomAttendanceTotalsComponent,
	NumberofCardsPrintedComponent,
	//AdvisoryHRAttendanceComponent,
	// StudentsByInfractionComponent,
	FinesOwedSummaryComponent,
	ActiveBarcodesComponent,
	//DailyMealCodesComponent,
	//IDCardsPrintedComponent,
	EntryAlertGroupedDetailsComponent,
	StudentsSuspendedHistoryComponent,
	// EntryStatusByTimeComponent,
	PhotosbyComponent,
	PhotoLabelsComponent,
	TeacherAttendanceVerificationComponent,
	//ClassAttendanceTrackingComponent,
	DailyBulletinComponent,
	IncompleteStudentAddressComponent,
	FinesPaidComponent,
	StudentScheduleLabelsComponent,
	FinesOwedComponent,
	StaffPhotos3ColumnsComponent,
	StaffPhotos4ColumnsComponent,
	//StudentClassAttendanceComponent,
	//ClassRosterComponent,
	GroupActionComponent,
	ClassAttendanceSummaryComponent,
	// TimeStampScanningComponent,
	MeritsDemeritsComponent,
	// MealsChargedBySubsidyComponent,
	MealAccountBalanceComponent,
	EntryAlertGroupedComponent,
	ClassAttendanceTrackingDetailsComponent,
	StudentCardStatusComponent,
	ScanEntryExitExceptionsComponent,
	IncidentsbyInfractionComponent,
	IncidentsbyLocationComponent,
	IncidentsbyStudentComponent,
	IncidentsbyIncidentTimeComponent,
	IncidentsbyInfractionLevelComponent,
	IncidentsbyEthnicityComponent,
	IncidentsbyCohortComponent,
	SuspensionsNotAssignedMaximumDaysComponent,
	//SuspensionWorkflowDetailComponent,
	//InOutOfSchoolSuspensionsComponent,
	IncidentsbyMonthInfractionLevelComponent,
	IncidentsperYearper100StudentsComponent,
	IncidentsbyStaffComponent,
	ParentGuardianOptInComponent,
	OptInBarcodeCardComponent,
	ParentGuardianOptInBarcodeComponent,
	GuardianCommunicationComponent,
	StaffInOutScanComponent,
	PhotoLabels3ColumnsComponent,
	HallPassReportComponent,
	//StudentAttendanceHistoryComponent,
	InstructorMeritsDemeritsComponent,
	IndividualStudentMeritComponent,
	MealAccountDepositComponent,
	MealTypeCountsComponent,
	MarkRosterComponent,
	//ConvertedIncidentsComponent,
	PeriodAttendanceCountsComponent,
	//StudentswithMissingAlertsComponent,
	VisitorsbyStatusComponent,
	VisitorLogsbyVisitorComponent,
	//VisitorLogsbyDateComponent,
	VisitorsPhotos3ColsComponent,
	VisitorsPhotos4ColsComponent,
	DetentionOwedComponent,
	DetentionSummaryComponent,
	DetentionBalanceComponent,
	VisitorsTodayComponent,
	EntryAlertbyContainerComponent,
	VisitorLogsbyPassTemplateComponent,
	VisitorsbyContainerComponent,
	VisitorSummaryComponent,
	PrincipalSchoolStatisticsComponent,
	DailyHotListComponent,
	HotListedCardUsageComponent,
	CardStatusComponent,
	StudentCaassTransactionsComponent,
	CardUsageDuringSchoolAbsenceComponent,
	//InstructorMissingSectionComponent,
	MTACardAbuseCountsComponent,
	RidingBusDuringSchoolComponent,
	//StudentClassAttendanceReconciliationComponent,
	//PhotoBookComponent,
	//StudentAttendanceStatusComponent
} from "./index";

import { ReportService } from "./report.service";
import { SectionService } from "./report-services/section.service";
import { AbuseCountService } from "./report-services/abuse-count.service";
import { MTADistrictSchoolService } from "./report-services/mta-district-school.service";
import { AcademyService } from "./report-services/academy.service";
import { ActionTypeService } from "./report-services/action-type.service";
import { AttendanceStatusService } from "./report-services/attendance-status.service";
import { BalHiService } from "./report-services/bal-hi.service";
import { BalLoService } from "./report-services/bal-lo.service";
import { CardTemplateService } from "./report-services/card-template.service";
import { ClassAttendanceEntryTypeService } from "./report-services/class-attendance-entry-type.service";
import { ClassAttendanceStatusService } from "./report-services/class-attendance-status.service";
import { ColumnSpaceService } from "./report-services/column-space.service";
import { CourseService } from "./report-services/course.service";
import { Course1Service } from "./report-services/course1.service";
import { Course2Service } from "./report-services/course2.service";
import { DayService } from "./report-services/day.service";
import { DistrictSchoolService } from "./report-services/district-school.service";
import { EndMonthService } from "./report-services/end-month.service";
import { EndYearService } from "./report-services/end-year.service";
import { EntryTypeService } from "./report-services/entry-type.service";
import { EthnicityService } from "./report-services/ethnicity.service";
import { EventScanTypeService } from "./report-services/event-scan-type.service";
import { ExclusionService } from "./report-services/exclusion.service";
import { FacilityLocationService } from "./report-services/facility-location.service";
import { GradeLevelService } from "./report-services/grade-level.service";
import { GroupService } from "./report-services/group.service";
import { HomeroomService } from "./report-services/homeroom.service";
import { ImageLogoService } from "./report-services/image-logo.service";
import { InfractionService } from "./report-services/infraction.service";
import { InfractionLevelService } from "./report-services/infraction-level.service";
import { InstructorService } from "./report-services/instructor.service";
import { InstructorPersonService } from "./report-services/instructor-person.service";
import { LabelHeightService } from "./report-services/label-height.service";
import { LeftMarginService } from "./report-services/left-margin.service";
import { MealService } from "./report-services/meal.service";
import { MealSubsidyTypeService } from "./report-services/meal-subsidy-type.service";
import { MstrDateService } from "./report-services/m-str-date.service";
import { MTACardTypeService } from "./report-services/mta-card-type.service";
import { MTAHotListStatusService } from "./report-services/mta-hotlist-status.service";
import { NotificationTypeService } from "./report-services/notification-type.service";
import { NumAbsentsService } from "./report-services/num-absents.service";
import { NumberOfService } from "./report-services/number-of.service";
import { NumCardsService } from "./report-services/num-cards.service";
import { NumCutsService } from "./report-services/num-cuts.service";
import { NumOfDaysService } from "./report-services/num-of-days.service";
import { NumTardiesService } from "./report-services/num-tardies.service";
import { PeriodService } from "./report-services/period.service";
import { PersonService } from "./report-services/person.service";
import { PersonTypeService } from "./report-services/person-type.service";
import { PrimarySortService } from "./report-services/primary-sort.service";
import { ReasonService } from "./report-services/reason.service";
import { ScanStationService } from "./report-services/scan-station.service";
import { SchoolGroupService } from "./report-services/school-group.service";
import { SecondarySortService } from "./report-services/secondary-sort.service";
import { SectionNoService } from "./report-services/section-no.service";
import { SemesterService } from "./report-services/semester.service";
import { StaffPersonService } from "./report-services/staff-person.service";
import { StaffTypeService } from "./report-services/staff-type.service";
import { StartMonthService } from "./report-services/start-month.service";
import { StartYearService } from "./report-services/start-year.service";
import { StudentService } from "./report-services/student.service";
import { SuspensionTypeService } from "./report-services/suspension-type.service";
import { TeacherPersonService } from "./report-services/teacher-person.service";
import { TimeScanTypeService } from "./report-services/time-scan-type.service";
import { TopMarginService } from "./report-services/top-margin.service";
import { VisitorStatusService } from "./report-services/visitor-status.service";
import { VisitorTypeService } from "./report-services/visitor-type.service";
import { YearService } from "./report-services/year.service";
import { ReportUsageComponent } from "./report-usage/report-usage.component";
import { DistrictOneCardExpressQueueComponent } from "./district-one-card-express-queue/district-one-card-express-queue.component";
import { DepotPQStatusService } from "./report-services/depot-pq-status.service";
import { DistrictOneCardExpressDailyBillingComponent } from "./district-one-card-express-daily-billing/district-one-card-express-daily-billing.component";
import { DistrictOneCardExpressShippingOrderComponent } from "./district-one-card-express-shipping-order/district-one-card-express-shipping-order.component";
import { DistrictMTAStudentRideTimesComponent } from "./district-mtastudent-ride-times/district-mtastudent-ride-times.component";
import { MTADistrictStatisticsChartComponent } from "./mtadistrict-statistics-chart/mtadistrict-statistics-chart.component";
import { DistrictSuspensionWorkflowDetailComponent } from "./district-suspension-workflow-detail/district-suspension-workflow-detail.component";
import { DistrictDisciplineActionTierCountsComponent } from "./district-discipline-action-tier-counts/district-discipline-action-tier-counts.component";
import { DistrictAttendanceSummaryComponent } from "./district-attendance-summary/district-attendance-summary.component";
import { DistrictCAASSUsageComponent } from "./district-caassusage/district-caassusage.component";
import { DistrictRatioIntoOutofSchoolSuspensionsComponent } from "./district-ratio-into-outof-school-suspensions/district-ratio-into-outof-school-suspensions.component";
import { DistrictReferralsByCohortComponent } from "./district-referrals-by-cohort/district-referrals-by-cohort.component";
import { DistrictReferralsByEthnicityComponent } from "./district-referrals-by-ethnicity/district-referrals-by-ethnicity.component";
import { DistrictReferralsByHarassmentComponent } from "./district-referrals-by-harassment/district-referrals-by-harassment.component";
import { HarassmentReasonService } from "./report-services/harassment-reason.service";
import { DistrictReferralsByIncidentTimeComponent } from "./district-referrals-by-incident-time/district-referrals-by-incident-time.component";
import { DistrictReferralsByInfractionComponent } from "./district-referrals-by-infraction/district-referrals-by-infraction.component";
import { DistrictReferralsByInfractionLevelComponent } from "./district-referrals-by-infraction-level/district-referrals-by-infraction-level.component";
import { DistrictReferralsByLocationComponent } from "./district-referrals-by-location/district-referrals-by-location.component";
import { DistrictReferralsPerYearPer100StudentsComponent } from "./district-referrals-per-year-per100-students/district-referrals-per-year-per100-students.component";
import { DistrictManifestationReferralsInComplianceComponent } from "./district-manifestation-referrals-in-compliance/district-manifestation-referrals-in-compliance.component";
import { DistrictMonthlyReferralAveragesComponent } from "./district-monthly-referral-averages/district-monthly-referral-averages.component";
import { DistrictScanStationTrackingComponent } from "./district-scan-station-tracking/district-scan-station-tracking.component";
import { DistrictSchoolTotalsComponent } from "./district-school-totals/district-school-totals.component";
import { DistrictSuspensionStepsOutOfComplianceComponent } from "./district-suspension-steps-out-of-compliance/district-suspension-steps-out-of-compliance.component";
import { DistrictSuspensionsNotAssignedMaximumDaysComponent } from "./district-suspensions-not-assigned-maximum-days/district-suspensions-not-assigned-maximum-days.component";
import { ReportMaintenanceComponent } from "./report-maintenance/report-maintenance.component";
import { SchoolMessengerAttendanceComponent } from "./school-messenger-attendance/school-messenger-attendance.component";
import { BooksForInstructorComponent } from "./books-for-instructor/books-for-instructor.component";
import { BookInventoryComponent } from "./book-inventory/book-inventory.component";
import { BooksDistributedComponent } from "./books-distributed/books-distributed.component";
import { PickListByHomeRoomComponent } from "./pick-list-by-home-room/pick-list-by-home-room.component";
import { BookInventoryBarcodeComponent } from "./book-inventory-barcode/book-inventory-barcode.component";
import { BooksDistributedBarcodeComponent } from "./books-distributed-barcode/books-distributed-barcode.component";
import { CustomDetention1Component } from "./custom-detention1/custom-detention1.component";
import { IndividualStudentPBISComponent } from "./individual-student-pbis/individual-student-pbis.component";
import { InstructorPBISComponent } from "./instructor-pbis/instructor-pbis.component";
import { PBISHistoryComponent } from "./pbis-history/pbis-history.component";
import { ActiveBarcodesScannableComponent } from "./active-barcodes-scannable/active-barcodes-scannable.component";
import { MergeToGroupDialogComponent } from "./merge-to-group-dialog/merge-to-group-dialog.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DataService_MergeToGroup } from "./merge-to-group-dialog/shared/data.service";
import { MergeToGroupStudentTableComponent } from "./merge-to-group-dialog/merge-to-group-student-table/merge-to-group-student-table.component";
import { VisitorBlockListComponent } from "./visitor-block-list/visitor-block-list.component";
import { TransitRiderDataComponent } from "./transit-rider-data/transit-rider-data.component";
import { MsVisitorsComponent } from "./ms-visitors/ms-visitors.component";
import { MsVisitorLogComponent } from "./ms-visitor-log/ms-visitor-log.component";
import { MsBlockListComponent } from "./ms-block-list/ms-block-list.component";
import { MsFacilityTimeComponent } from "./ms-facility-time/ms-facility-time.component";
import { MsVisitorTimeInFacilitiesComponent } from "./ms-visitor-time-in-facilities/ms-visitor-time-in-facilities.component";
import { HsSchoolLogComponent } from "./hs-school-log/hs-school-log.component";
import { HsSchoolSummaryComponent } from "./hs-school-summary/hs-school-summary.component";
import { NotifyStudentRegComponent } from "./notify-student-reg/notify-student-reg.component";
import { DataService_NotifyReport } from "./notify-report-services/notifyreport.service";
import { NotifyStudentListParentsComponent } from "./notify-student-list-parents/notify-student-list-parents.component";
import { NotifyParentListStudentsComponent } from "./notify-parent-list-students/notify-parent-list-students.component";
import { ScanStationBadScanDataComponent } from "./scan-station-bad-scan-data/scan-station-bad-scan-data.component";
import { StudentQrCodesComponent } from "./student-qr-codes/student-qr-codes.component";
import { StaffBarcodeExportComponent } from "./staff-barcode-export/staff-barcode-export.component";
import { MsUsageComponent } from "./ms-usage/ms-usage.component";
import { StudentDigitalIDRegComponent } from "./student-digital-idreg/student-digital-idreg.component";
import { TimestampTimeInEventComponent } from "./timestamp-time-in-event/timestamp-time-in-event.component";
import { StudentOldPhotosComponent } from "./student-old-photos/student-old-photos.component";
import { DistrictCaassUsageSimpleComponent } from "./district-caass-usage-simple/district-caass-usage-simple.component";
import { DistrictCaassUsageFullComponent } from "./district-caass-usage-full/district-caass-usage-full.component";
import { TempIdCardsPrintedComponent } from "./temp-id-cards-printed/temp-id-cards-printed.component";
import { ParentPortalUsersByStudentComponent } from "./parent-portal-users-by-student/parent-portal-users-by-student.component";
import { StudentPortalUsersComponent } from "./student-portal-users/student-portal-users.component";
import { StaffPortalUsersComponent } from "./staff-portal-users/staff-portal-users.component";
import { ParentPortalAllUsersComponent } from "./parent-portal-all-users/parent-portal-all-users.component";
import { StudentWithdrawTransferComponent } from "./student-withdraw-transfer/student-withdraw-transfer.component";
import { CaassPassStudentTotalsComponent } from "./caass-pass-student-totals/caass-pass-student-totals.component";
import { AttendanceByLocationComponent } from "./attendance-by-location/attendance-by-location.component";
import { BusRunningLateComponent } from "./bus-running-late/bus-running-late.component";
import { InactiveCardsScannedComponent } from "./inactive-cards-scanned/inactive-cards-scanned.component";
import { PublicTransitRiderStatusComponent } from "./public-transit-rider-status/public-transit-rider-status.component";
import { BlockListScansComponent } from "./block-list-scans/block-list-scans.component";
import { AccessScanningComponent } from "./access-scanning/access-scanning.component";
import { ExitScanningComponent } from "./exit-scanning/exit-scanning.component";
import { EventScanningComponent } from "./event-scanning/event-scanning.component";
import { TimestampScanningBySchoolComponent } from './timestamp-scanning-by-school/timestamp-scanning-by-school.component';
import { AttendanceWithExcuseComponent } from './attendance-with-excuse/attendance-with-excuse.component';
import { AlreadyScannedInComponent } from './already-scanned-in/already-scanned-in.component';
import { StudentsNotRidingComponent } from './students-not-riding/students-not-riding.component';
import { StudentsNeverOnBusComponent } from './students-never-on-bus/students-never-on-bus.component';
import { TimescanScannedIntoEventComponent } from './timescan-scanned-into-event/timescan-scanned-into-event.component';

@NgModule({
	declarations: [
		ReportComponent,
		AdvisoryHRAttendanceComponent,
		AttendanceByTypeComponent,
		AttendanceWithGroupingComponent,
		EntryAlertComponent,
		ClassRosterComponent,
		DailyMealCodesComponent,
		EntryStatusByTimeComponent,
		MealsChargedBySubsidyComponent,
		PerfectAttendanceComponent,
		ClassAttendanceTrackingComponent,
		IDCardsPrintedComponent,
		InstructorMissingSectionComponent,
		// ScanStationAttendancesComponent,
		StudentAttendanceHistoryComponent,
		StudentAttendanceStatusComponent,
		StudentClassAttendanceComponent,
		InstructorMissingSectionComponent,
		EntryTypeComponent,
		StudentWithoutPhotosComponent,
		StudentTardiesWithTimesComponent,
		TimeStampScanningComponent,
		StudentStatusForTheDayComponent,
		StudentAbsentTardyExcuseComponent,
		StudentClassAttendanceReconciliationComponent,
		PhotoBookComponent,
		ScanStationAttendancesComponent,
		StudentWithAlertComponent,
		VisitorlogsbydateComponent,
		ConvertedIncidentsComponent,
		//DetentionBalanceComponent,
		//DetentionOwedComponent,
		InOutOfSchoolSuspensionsComponent,
		StudentsByInfractionComponent,
		StudentsWithMissingAlertsComponent,
		SuspensionWorkflowDetailComponent,
		//SuspensionsNotAssignedMaximumComponent

		//Generated
		AlphaStudentDetailsComponent,
		AttendancebyDayComponent,
		AttendanceSummaryComponent,
		CutsAbsenceTardyComponent,
		EarlyReleaseComponent,
		//EntryTypeComponent,
		ExceptionStationComponent,
		ScanStationsSummaryComponent,
		WeeklyHomeroomSheetComponent,
		// StudentStatusForTheDayComponent,
		StudentCutsMTDYTDComponent,
		StudentCutsMTDYTDDetailComponent,
		StudentsonSuspensionComponent,
		// StudentsWithoutPhotosComponent,
		LockersComponent,
		//PerfectAttendanceComponent,
		StudentCutsbyNumberComponent,
		StudentMealSubsidyTypesComponent,
		//EntryAlertComponent,
		AlphaStaffComponent,
		StudentIDCardHistoryComponent,
		AlphaStudentListComponent,
		EntryTypeCountsComponent,
		HomeroomAttendanceTotalsComponent,
		NumberofCardsPrintedComponent,
		//AdvisoryHRAttendanceComponent,
		// StudentsByInfractionComponent,
		FinesOwedSummaryComponent,
		ActiveBarcodesComponent,
		//DailyMealCodesComponent,
		//IDCardsPrintedComponent,
		EntryAlertGroupedDetailsComponent,
		StudentsSuspendedHistoryComponent,
		// EntryStatusByTimeComponent,
		PhotosbyComponent,
		PhotoLabelsComponent,
		TeacherAttendanceVerificationComponent,
		//ClassAttendanceTrackingComponent,
		DailyBulletinComponent,
		IncompleteStudentAddressComponent,
		FinesPaidComponent,
		StudentScheduleLabelsComponent,
		FinesOwedComponent,
		StaffPhotos3ColumnsComponent,
		StaffPhotos4ColumnsComponent,
		//StudentClassAttendanceComponent,
		//ClassRosterComponent,
		GroupActionComponent,
		ClassAttendanceSummaryComponent,
		// TimeStampScanningComponent,
		MeritsDemeritsComponent,
		// MealsChargedBySubsidyComponent,
		MealAccountBalanceComponent,
		EntryAlertGroupedComponent,
		ClassAttendanceTrackingDetailsComponent,
		StudentCardStatusComponent,
		ScanEntryExitExceptionsComponent,
		IncidentsbyInfractionComponent,
		IncidentsbyLocationComponent,
		IncidentsbyStudentComponent,
		IncidentsbyIncidentTimeComponent,
		IncidentsbyInfractionLevelComponent,
		IncidentsbyEthnicityComponent,
		IncidentsbyCohortComponent,
		SuspensionsNotAssignedMaximumDaysComponent,
		//SuspensionWorkflowDetailComponent,
		//InOutOfSchoolSuspensionsComponent,
		IncidentsbyMonthInfractionLevelComponent,
		IncidentsperYearper100StudentsComponent,
		IncidentsbyStaffComponent,
		ParentGuardianOptInComponent,
		OptInBarcodeCardComponent,
		ParentGuardianOptInBarcodeComponent,
		GuardianCommunicationComponent,
		StaffInOutScanComponent,
		PhotoLabels3ColumnsComponent,
		HallPassReportComponent,
		//StudentAttendanceHistoryComponent,
		InstructorMeritsDemeritsComponent,
		IndividualStudentMeritComponent,
		MealAccountDepositComponent,
		MealTypeCountsComponent,
		MarkRosterComponent,
		//ConvertedIncidentsComponent,
		PeriodAttendanceCountsComponent,
		//StudentswithMissingAlertsComponent,
		VisitorsbyStatusComponent,
		VisitorLogsbyVisitorComponent,
		//VisitorLogsbyDateComponent,
		VisitorsPhotos3ColsComponent,
		VisitorsPhotos4ColsComponent,
		DetentionOwedComponent,
		DetentionSummaryComponent,
		DetentionBalanceComponent,
		VisitorsTodayComponent,
		EntryAlertbyContainerComponent,
		VisitorLogsbyPassTemplateComponent,
		VisitorsbyContainerComponent,
		VisitorSummaryComponent,
		PrincipalSchoolStatisticsComponent,
		DailyHotListComponent,
		HotListedCardUsageComponent,
		CardStatusComponent,
		StudentCaassTransactionsComponent,
		CardUsageDuringSchoolAbsenceComponent,
		//InstructorMissingSectionComponent,
		MTACardAbuseCountsComponent,
		RidingBusDuringSchoolComponent,
		ReportUsageComponent,
		DistrictOneCardExpressQueueComponent,
		DistrictOneCardExpressDailyBillingComponent,
		DistrictOneCardExpressShippingOrderComponent,
		DistrictMTAStudentRideTimesComponent,
		MTADistrictStatisticsChartComponent,
		DistrictSuspensionWorkflowDetailComponent,
		DistrictDisciplineActionTierCountsComponent,
		DistrictAttendanceSummaryComponent,
		DistrictCAASSUsageComponent,
		DistrictRatioIntoOutofSchoolSuspensionsComponent,
		DistrictReferralsByCohortComponent,
		DistrictReferralsByEthnicityComponent,
		DistrictReferralsByHarassmentComponent,
		DistrictReferralsByIncidentTimeComponent,
		DistrictReferralsByInfractionComponent,
		DistrictReferralsByInfractionLevelComponent,
		DistrictReferralsByLocationComponent,
		DistrictReferralsPerYearPer100StudentsComponent,
		DistrictManifestationReferralsInComplianceComponent,
		DistrictMonthlyReferralAveragesComponent,
		DistrictScanStationTrackingComponent,
		DistrictSchoolTotalsComponent,
		DistrictSuspensionStepsOutOfComplianceComponent,
		DistrictSuspensionsNotAssignedMaximumDaysComponent,
		ReportMaintenanceComponent,
		SchoolMessengerAttendanceComponent,
		BooksForInstructorComponent,
		BookInventoryComponent,
		BooksDistributedComponent,
		PickListByHomeRoomComponent,
		BookInventoryBarcodeComponent,
		BooksDistributedBarcodeComponent,
		CustomDetention1Component,
		IndividualStudentPBISComponent,
		InstructorPBISComponent,
		PBISHistoryComponent,
		ActiveBarcodesScannableComponent,
		MergeToGroupDialogComponent,
		MergeToGroupStudentTableComponent,
		VisitorBlockListComponent,
		TransitRiderDataComponent,
		MsVisitorsComponent,
		MsVisitorLogComponent,
		MsBlockListComponent,
		MsFacilityTimeComponent,
		MsVisitorTimeInFacilitiesComponent,
		HsSchoolLogComponent,
		HsSchoolSummaryComponent,
		NotifyStudentRegComponent,
		NotifyStudentListParentsComponent,
		NotifyParentListStudentsComponent,
		ScanStationBadScanDataComponent,
		StudentQrCodesComponent,
		StaffBarcodeExportComponent,
		MsUsageComponent,
		StudentDigitalIDRegComponent,
		TimestampTimeInEventComponent,
		StudentOldPhotosComponent,
		DistrictCaassUsageSimpleComponent,
		DistrictCaassUsageFullComponent,
		TempIdCardsPrintedComponent,
		ParentPortalUsersByStudentComponent,
		StudentPortalUsersComponent,
		StaffPortalUsersComponent,
		ParentPortalAllUsersComponent,
		StudentWithdrawTransferComponent,
		CaassPassStudentTotalsComponent,
		AttendanceByLocationComponent,
		BusRunningLateComponent,
		InactiveCardsScannedComponent,
		PublicTransitRiderStatusComponent,
		BlockListScansComponent,
		AccessScanningComponent,
		ExitScanningComponent,
		EventScanningComponent,
  TimestampScanningBySchoolComponent,
  AttendanceWithExcuseComponent,
  AlreadyScannedInComponent,
  StudentsNotRidingComponent,
  StudentsNeverOnBusComponent,
  TimescanScannedIntoEventComponent,
		//StudentClassAttendanceReconciliationComponent,
		//PhotoBookComponent,
		//StudentAttendanceStatusComponent
	],

	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		CalendarModule,
		ConfirmDialogModule,
		DialogModule,
		FileUploadModule,
		HttpClientModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		AccordionModule,
		CheckboxModule,
		SchoolselectorModule,
		BrowserAnimationsModule,
	],
	providers: [
		ReportService,
		AbuseCountService,
		AcademyService,
		ActionTypeService,
		AttendanceStatusService,
		BalHiService,
		BalLoService,
		CardTemplateService,
		ClassAttendanceEntryTypeService,
		ClassAttendanceStatusService,
		ColumnSpaceService,
		CourseService,
		Course1Service,
		Course2Service,
		DayService,
		DistrictSchoolService,
		EndMonthService,
		EndYearService,
		EntryTypeService,
		EthnicityService,
		EventScanTypeService,
		ExclusionService,
		FacilityLocationService,
		GradeLevelService,
		GroupService,
		HomeroomService,
		ImageLogoService,
		InfractionService,
		InfractionLevelService,
		InstructorService,
		InstructorPersonService,
		LabelHeightService,
		LeftMarginService,
		MealService,
		MealSubsidyTypeService,
		MstrDateService,
		MTACardTypeService,
		MTADistrictSchoolService,
		MTAHotListStatusService,
		NotificationTypeService,
		NumAbsentsService,
		NumberOfService,
		NumCardsService,
		NumCutsService,
		NumOfDaysService,
		NumTardiesService,
		PeriodService,
		PersonService,
		PersonTypeService,
		PrimarySortService,
		ReasonService,
		ScanStationService,
		SchoolGroupService,
		SecondarySortService,
		SectionNoService,
		SemesterService,
		StaffPersonService,
		StaffTypeService,
		StartMonthService,
		StartYearService,
		StudentService,
		SuspensionTypeService,
		TeacherPersonService,
		TimeScanTypeService,
		TopMarginService,
		VisitorStatusService,
		VisitorTypeService,
		YearService,
		SectionService,
		DepotPQStatusService,
		HarassmentReasonService,
		DataService_MergeToGroup,
		DataService_NotifyReport,
	],
})
export class ReportModule {}
